import { render, staticRenderFns } from "./interfacemonitoring.vue?vue&type=template&id=4486b154"
import script from "./interfacemonitoring.vue?vue&type=script&lang=js"
export * from "./interfacemonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports